import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  // apiKey: `${process.env.REACT_APP_API_KEY}`,
  // authDomain: `${process.env.REACT_APP_AUTH_DOMAIN}`,
  apiKey: "AIzaSyC9nE13W9ZOpSqHk4AK98VuGf9MMDS-euI",
  authDomain: "academates-c19f3.firebaseapp.com",
  projectId: "academates-c19f3",
  storageBucket: "academates-c19f3.appspot.com",
  messagingSenderId: "1047447655048",
  appId: "1:1047447655048:web:d5b3cb127d63a2037a453d",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const storage = getStorage(app);
export const db = getFirestore(app);
